import { render, staticRenderFns } from "./inentSim.vue?vue&type=template&id=584804e0&scoped=true&"
import script from "./inentSim.vue?vue&type=script&lang=js&"
export * from "./inentSim.vue?vue&type=script&lang=js&"
import style0 from "./inentSim.vue?vue&type=style&index=0&id=584804e0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584804e0",
  null
  
)

export default component.exports